<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="container-fluid">
        <img :src="require('@/assets/icons/logo.svg')" alt="logo DSP Tool" style="height: 25px; width: auto; margin-right: 12px;" />
        VT-Mar
        <!-- Right side of Navbar -->
        <div class="collapse navbar-collapse" id="navbarToggler">
          <ul class="nav navbar-nav navbar-right ml-auto ">
            <li class="nav-item dropdown mr-5 nav-inicio">
              <a v-if="isLoggedIn" id="navbarDropdown" class=" dropdown-toggle link-1" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <!-- <img :src="require('@/assets/icons/icon-user.svg')" alt="Profile picture" class="profile-picture"/> -->
                <p v-if="fullname != ''" class="d-inline-block nav-user m-0 link-1">{{fullname}}</p>
                <p v-else class="d-inline-block nav-user m-0 link-1">{{username}}</p>
              </a>
              <!-- User options pop up -->
              <div class="dropdown-menu dropdown-menu-right dropdown-user" aria-labelledby="navbarDropdown">
                <div class="popup-body">
                  <!-- <div class="line-separator"><hr /></div> -->
                  <div>
                    <div @click="logout" class="dropdown-item pointer">
                      &nbsp;Logout
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

    </nav>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'

export default {
  name: "vtHeader",
  components: {
  },
  data() {
    return {
    };
  },
  computed: { 
    ...mapGetters("user",{
      isLoggedIn: 'isLoggedIn',
      username: 'username',
      fullname: 'fullname',
      is_admin: 'is_admin'
    }) 
  },
  methods:{
    logout: function () {
      this.$store.dispatch('user/logout')
      .then(resp => { console.log(resp)})
      .catch(err => err)
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang= "scss" scoped>

.nav-inicio {
    align-content: center;
    display: grid
}

.profile-picture{
    width: 25px;
    padding-right: 5px;
}

.dropdown-user {
  z-index: 1000000;
}



</style>
